



















































































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import MailboxSettingsSavedRepliesReply from './components/mailbox-settings-saved-replies-reply.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import {
  IMailboxesOutputSavedRepliesSavedReply,
  INameAndDescription,
} from '@/api/types/response.types'
import {
  IMailboxesInputCreateSavedReply,
  IMailboxesInputUpdateSavedReply,
} from '@/api/types/request.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'MailboxSettingsSavedReplies',

  metaInfo(): any {
    return {
      title: `Saved Replies - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    MailboxSettingsSavedRepliesReply,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      editingID: null,
      name: '',
      savedReplyVars: [] as INameAndDescription[],
      savedReplies: [] as IMailboxesOutputSavedRepliesSavedReply[],
      upsertingSavedReply: {} as IMailboxesInputUpdateSavedReply,
      modalOpened: false,
      rules: {
        title: [
          {
            required: true,
            trigger: 'submit',
            message: 'Title is required',
          },
        ],
        reply: [
          {
            required: true,
            trigger: 'submit',
            message: 'Reply is required',
          },
        ],
      },
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    isEditing(): boolean {
      return this.editingID != null
    },
    hasSavedReplies(): boolean {
      return this.savedReplies.length > 0
    },
  },

  watch: {
    modalOpened(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.savedReplyForm_Title.focus()
        })
      }
    },
  },

  async created() {
    this.isLoading = true
    await this.getSavedRepliesInfo()
    this.isLoading = false
  },

  methods: {
    getSavedReply(id: number) {
      return this.savedReplies.find(sr => sr.id === id)
    },
    async getSavedRepliesInfo() {
      try {
        const response = await MailboxesAPI.get_SavedReplies(this.id)
        this.name = response.name
        this.savedReplyVars = response.listSavedReplyVars
        this.savedReplies = response.listSavedReplies
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async upsertReply() {
      // @ts-ignore
      this.$refs.upsertReplyForm.validate((valid: boolean) => {
        if (valid) {
          this.isEditing ? this.updateSavedReply() : this.createSavedReply()
          this.closeModal()
        }
      })
    },

    beginEditReply(id: number): void {
      this.upsertingSavedReply = this.getSavedReply(id)
      this.modalOpened = true
      this.editingID = id
    },

    beginCreateReply(): void {
      this.upsertingSavedReply = {} as IMailboxesInputUpdateSavedReply
      this.modalOpened = true
      this.editingID = null
    },

    async removeReply(id: number) {
      await this.$confirm(
        `Are you sure you want to delete this saved reply?<br />
         This cannot be undone.`,
        {
          dangerouslyUseHTMLString: true,
          center: true,
          confirmButtonText: 'Yes, Delete',
          confirmButtonClass: 'el-button--strawberry',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'el-button--text',
          type: 'warning',
          title: `Delete Saved Reply`,
        },
      )
      await this.deleteSavedReply(id)
    },

    closeModal(): void {
      this.modalOpened = false
      // @ts-ignore
      this.$refs.upsertReplyForm.clearValidate()
    },

    async createSavedReply() {
      try {
        this.isSubmitting = true
        const data = this.upsertingSavedReply as IMailboxesInputCreateSavedReply
        const response = await MailboxesAPI.post_CreateSavedReply(this.id, data)
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        await this.getSavedRepliesInfo()
        this.isSubmitting = false
      }
    },

    async updateSavedReply() {
      try {
        this.isSubmitting = true
        const data = this.upsertingSavedReply as IMailboxesInputUpdateSavedReply
        const response = await MailboxesAPI.put_UpdateSavedReply(
          this.id,
          this.editingID,
          data,
        )
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        await this.getSavedRepliesInfo()
        this.isSubmitting = false
      }
    },

    async deleteSavedReply(id: number) {
      try {
        this.isSubmitting = true
        const response = await MailboxesAPI.delete_DeleteSavedReply(this.id, id)
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        await this.getSavedRepliesInfo()
        this.isSubmitting = false
      }
    },
  },
})
